import React from "react";
import CustomerFilterList from "../../components/customer/CustomerFilterList";

const CustomerFiltersPage = () => {
    return <CustomerFilterList/>
}

export default CustomerFiltersPage;